
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark-gray text-white pt-20 pb-10 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-20">
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-3">
            <div className="bg-primary text-white w-8 h-8 rounded-lg flex items-center justify-center font-black">M</div>
            <h2 className="text-xl font-black tracking-tight uppercase">MargateRoofing</h2>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed">
            Florida's most trusted roofing specialists since 1998. Quality materials, expert craftsmanship, and unmatched customer service.
          </p>
        </div>

        <div>
          <h4 className="text-lg font-bold mb-8 relative after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-10 after:h-1 after:bg-primary">Quick Links</h4>
          <ul className="flex flex-col gap-4 text-gray-400 text-sm">
            <li><a href="#services" className="hover:text-primary transition-colors">Roof Repair</a></li>
            <li><a href="#services" className="hover:text-primary transition-colors">Full Replacement</a></li>
            <li><a href="#services" className="hover:text-primary transition-colors">Storm Restoration</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-bold mb-8 relative after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-10 after:h-1 after:bg-primary">Service Areas</h4>
          <ul className="flex flex-col gap-4 text-gray-400 text-sm">
            <li>Margate, FL</li>
            <li>Coral Springs, FL</li>
            <li>Coconut Creek, FL</li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-bold mb-8 relative after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-10 after:h-1 after:bg-primary">Contact Us</h4>
          <ul className="flex flex-col gap-5 text-gray-400 text-sm">
            <li className="leading-relaxed">1234 N State Road 7,<br/>Margate, FL 33063</li>
            <li className="font-bold text-white">(555) 123-4567</li>
            <li className="hover:text-white transition-colors">info@margateroofing.com</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 border-t border-gray-800 pt-10 text-center">
        <p className="text-gray-500 text-xs">© 2024 Margate Roofing Specialists. Licensed & Insured #CCC1234567</p>
      </div>
    </footer>
  );
};

export default Footer;
